/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum TokenExchangeTypeEnum {
    RESTRICTED_ADMIN = 'RESTRICTED_ADMIN',
}